import React, { useState, useCallback } from "react";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import classes from "./PlanItem.module.scss";
import cn from "classnames";
import { When } from "@/components/common/When";
import { Button } from "@/components/common/Button";
import { IPlanItem } from "@/types/billing.types";
import { VARIANT } from "@/constant";
import { AiOutlineQrcode, AiOutlineScan, AiOutlineSetting, AiOutlineUserAdd } from "react-icons/ai";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { FiLayers } from "react-icons/fi";
import { FaCheck } from "react-icons/fa";
import { useTranslations } from "next-intl";
import IFThen from '@/components/common/IFThen';
export const PlanItem = (props: IPlanItem) => {
  const {
    item,
    index,
    discount,
    TEST_VARIANT,
    onSelectPlan,
    selectedPlanName,
    handleCheckout
  } = props;
  const {
    name,
    description,
    selected,
    limits,
    amount,
    billingTypeIndicator,
    subscribeButton,
    discountAmount,
    totalAmount,
    discountTotalAmount
  } = item || {};
  const t = useTranslations("PricingPlans");
  const [accordion, setAccordion] = useState<{
    index: number;
    open: boolean;
  }[]>([{
    index: 0,
    open: false
  }, {
    index: 1,
    open: true
  }, {
    index: 2,
    open: false
  }]);
  const handleAccordion = (index: number) => {
    const newAccordion = accordion.map(acc => {
      if (acc.index === index) {
        return {
          index: acc.index,
          open: !acc.open
        };
      }
      return acc;
    });
    setAccordion(newAccordion);
  };
  const iconColor = index === 0 ? "#0e595a" : selected ? "rgba(57, 153, 48, 1)" : " rgba(10, 147, 150, 1)";
  const getStatusAccordion = useCallback((index: number) => accordion.find(acc => acc.index === index)?.open, [index, accordion]);
  return <>
      <div onClick={onSelectPlan} data-test={TEST_VARIANT} data-testid={name} className={classes.plan_column} key={index + name?.toString()} id={`plan_${index + name?.toString()}`}>
        <div className={cn(classes.plan_column__item, {
        [classes.active]: selected,
        [classes.aqua]: !selected,
        [classes.advanceWidth]: selected,
        [classes.first]: index === 0
      })}>
          <div>
            <h3 className={cn(classes.plan_name, {
            [classes.green]: !!selected,
            [classes.aqua]: !selected
          })}>
              {name}
              <When condition={!!selected} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
                <span className={classes.plan_bandage}>{t("mostPopular")}</span>
              </When>
            </h3>
            <When condition={TEST_VARIANT === VARIANT.VariantC && selectedPlanName === name} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
              <div className={classes.check}>
                <FaCheck size={12} data-sentry-element="FaCheck" data-sentry-source-file="PlanItem.tsx" />
              </div>
            </When>
            <p className={classes.plan_des}>{description}</p>
            <div className={cn(classes.price_box, {
            [classes.price_not_eu]: item.payload.show_annually
          })}>
              <div className={cn(classes.plan_price, {
              [classes.discountExist]: discount
            })}>
                <p>
                  <div data-testid="price" className={classes.default_price}>
                    {amount}
                    <span className={classes.line}></span>
                  </div>
                </p>
                {discount && discountAmount}
                <span className={classes.month}>/{billingTypeIndicator}</span>
              </div>
              <span className={classes.price_text}>
                {item.periodIndicatorMessage}
              </span>
            </div>


            <div className={classes.detail_right}>
              <Button variant={selected ? "secondary" : "borderless"} className={cn({
              [classes.checkout_btn]: selected && !subscribeButton?.disabled,
              [classes.activePlan_btn]: subscribeButton?.disabled,
              [classes.inactive_btn]: !(selected && subscribeButton?.disabled)
            })} title={subscribeButton?.text ?? t("startFreeTrial")} isDisabled={subscribeButton?.disabled} onClick={handleCheckout} id={subscribeButton?.pastDue ? 'PricingRenewPlan_Button' : `${TEST_VARIANT}_${name?.toString()}`} data-sentry-element="Button" data-sentry-source-file="PlanItem.tsx" />
              {item.subscribeButton?.popup && <div className={classes.toolTip}>
                  <p className={classes.text}>{item.subscribeButton.popup}</p>
                </div>}
            </div>

            <div className={cn(classes.planDetails_box, {
            [classes.open]: getStatusAccordion(index)
          })}>
              <When condition={!!limits.dynamic_qr_codes} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
                <div className={classes.details_row}>
                  <span className={classes.detail_left}>
                    <AiOutlineQrcode color={iconColor} size={24} data-sentry-element="AiOutlineQrcode" data-sentry-source-file="PlanItem.tsx" />
                  </span>
                  <span className={cn(classes.detail_right, classes.button_tooltip)}>
                    {limits.dynamic_qr_codes} {t("perks.0.title")}
                    <div className={classes.toolTip}>
                      <p className={classes.text}>{t("perks.0.tooltip")}</p>
                    </div>
                  </span>
                </div>
              </When>
              <div className={classes.details_row}>
                <span className={classes.detail_left}>
                  <AiOutlineScan color={iconColor} size={24} data-sentry-element="AiOutlineScan" data-sentry-source-file="PlanItem.tsx" />
                </span>
                <span className={cn(classes.detail_right, classes.button_tooltip)}>
                  {limits.yearly_scans || t("unlimited")} {t("perks.1.title")}
                  <div className={classes.toolTip}>
                    <p className={classes.text}>{t("perks.1.tooltip")}</p>
                  </div>
                </span>
              </div>
              <When condition={!!limits.monthly_api_requests} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
                <div className={classes.details_row}>
                  <span className={classes.detail_left}>
                    <AiOutlineSetting color={iconColor} size={24} data-sentry-element="AiOutlineSetting" data-sentry-source-file="PlanItem.tsx" />
                  </span>
                  <span className={cn(classes.detail_right, classes.button_tooltip)}>
                    {limits.monthly_api_requests} {t("perks.2.title")}
                    <div className={classes.toolTip}>
                      <p className={classes.text}>{t("perks.2.tooltip")}</p>
                    </div>
                  </span>
                </div>
              </When>
              <When condition={!!limits.bulk_create} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
                <div className={classes.details_row}>
                  <span className={classes.detail_left}>
                    <FiLayers color={iconColor} size={24} data-sentry-element="FiLayers" data-sentry-source-file="PlanItem.tsx" />
                  </span>
                  <span className={cn(classes.detail_right, classes.button_tooltip)}>
                    {limits.bulk_create} {t("perks.3.title")}
                    <div className={classes.toolTip}>
                      <p className={classes.text}>{t("perks.3.tooltip")}</p>
                    </div>
                  </span>
                </div>
              </When>
              <When condition={!!limits.total_managers} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
                <div className={classes.details_row}>
                  <span className={classes.detail_left}>
                    <AiOutlineUserAdd color={iconColor} size={24} data-sentry-element="AiOutlineUserAdd" data-sentry-source-file="PlanItem.tsx" />
                  </span>
                  <span className={cn(classes.detail_right, classes.button_tooltip)}>
                    {limits.total_managers} {t("perks.4.title")}
                    <div className={classes.toolTip}>
                      <p className={classes.text}>{t("perks.4.tooltip")}</p>
                    </div>
                  </span>
                </div>
              </When>
              <When condition={name === "Professional"} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
                <div className={classes.details_row}>
                  <span className={classes.detail_left}>
                    <TfiHeadphoneAlt color={iconColor} size={24} data-sentry-element="TfiHeadphoneAlt" data-sentry-source-file="PlanItem.tsx" />
                  </span>
                  <span className={cn(classes.detail_right, classes.button_tooltip)}>
                    {t("perks.5.title")}
                    <div className={classes.toolTip}>
                      <p className={classes.text}>{t("perks.5.tooltip")}</p>
                    </div>
                  </span>
                </div>
              </When>
            </div>

            <When condition={TEST_VARIANT === VARIANT.VariantC} data-sentry-element="When" data-sentry-source-file="PlanItem.tsx">
              <button onClick={e => {
              e.stopPropagation();
              handleAccordion(index);
            }} className={classes.showFeatures}>
                {getStatusAccordion(index) ? "Hide" : "Show"} features{" "}
                {getStatusAccordion(index) ? <GoChevronUp size={16} /> : <GoChevronDown size={16} />}
              </button>
            </When>
          </div>
        </div>
      </div>
    </>;
};